import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';

import { Button, ButtonsContainer } from 'virtues-bootstrap';

export default function DictionaryPage({ submit, dictionary }) {
  const [useDictionary, setDictionary] = useState(dictionary);

  useEffect(() => {
    setDictionary(dictionary);
  }, [dictionary]);

  // eslint-disable-next-line camelcase
  const handleDictionaryChange = ({ updated_src }) => {
    setDictionary(updated_src);
    return useDictionary;
  };

  const handleSubmit = e => {
    // submit(dictionary);
    console.log(useDictionary);
  };

  return (
    <div>
      <ReactJson
        src={useDictionary}
        name={false}
        theme="hopscotch"
        onEdit={edit => handleDictionaryChange(edit)}
        onAdd={add => handleDictionaryChange(add)}
        onDelete={del => handleDictionaryChange(del)}
        collapsed
      />
      <ButtonsContainer>
        <Button onClick={handleSubmit}>Update</Button>
      </ButtonsContainer>
    </div>
  );
}

DictionaryPage.propTypes = {
  getDictionary: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dictionary: PropTypes.object.isRequired,
};
